import { Components, Theme } from '@mui/material/styles';

export default function MuiTooltip(theme: Theme): Components['MuiTooltip'] {
  return {
    defaultProps: {
      arrow: true,
    },
    styleOverrides: {
      tooltip: {
        backgroundColor: theme.palette.taiga.main,
        color: theme.palette.sand.main,
        padding: '6px 8px',
        borderRadius: '16px',
        cornerShape: 'squircle',
        ...theme.typography.subtitle3,
      },
      arrow: {
        '&:before': {
          backgroundColor: theme.palette.taiga.main,
        },
      },
    },
  };
}
